import React from 'react';
import { Dropdown } from '@trevor/ui-components';
import { SavedQueriesWidget } from './SavedQueriesWidget';

export const DropdownContent: React.FC<{
  isExistingLayer?: boolean;
}> = ({ isExistingLayer = false }) => (
  <Dropdown.Content isFixed={false} top={31} left={-1}>
    <SavedQueriesWidget isExistingLayer={isExistingLayer} />
  </Dropdown.Content>
);
